import { Link, LinkProps } from '@mui/material';
import Iconify from 'src/components/iconify/iconify';

interface Props {
  onClick?: LinkProps['onClick'];
  href?: LinkProps['href'];
  children?: React.ReactNode;
  icon?: string;
  iconSize?: number;
}

export default function CasLink2({ onClick, href, children, icon, iconSize = 16 }: Props) {
  return (
    <Link href={href} onClick={onClick}>
      {icon && <Iconify icon={icon} width={iconSize} />}
      {children}
    </Link>
  );
}
